<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { dashboards } from 'src/stores/features/dashboards';
	import { sortByPosition } from 'src/components/Lists/list-helpers';
	import type { DashWidgetEditType, ListRefType } from '../../dash-types';
	//Components
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	import DashWidgetPositionStep from './DashWidgetPositionStep.svelte';
	import { Button } from '@Shelly/shelly-design-system/index';
	import DashAddEditActionModal from 'src/components/AddActions/Wizards/DashAddEditActionModal.svelte';
	import { mapDashToAvatar } from '../../dash-helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { edit } from 'src/stores/ui/edit_lists';

	export let allDashRefs: ListRefType = {};
	export let editItem: DashWidgetEditType;
	export let hideSelectDash = false;

	let showAddDashModal = false;

	$: dashList = Object.values($dashboards)
		.sort(sortByPosition)
		.map((dash: any) => {
			return {
				id: dash.id,
				name: dash.name,
				selected: +editItem.dashboardId === +dash.id,
				disabled: false,
				...mapDashToAvatar(dash),
			};
		});

	const onSelectDash = (dashItem) => {
		editItem = {
			...editItem,
			dashboardId: dashItem.id,
		};

		dashList = dashList.map((dash) => {
			if (dashItem.id === dash.id) {
				return {
					...dash,
					selected: true,
				};
			}
			return {
				...dash,
				selected: false,
			};
		});
	};

	const onShowAddDashModal = () => {
		showAddDashModal = true;
	};
</script>

{#if !$edit && !hideSelectDash}
	<SelectList
		title={$format('label_select_dashboard', {
			default: 'Select dashboard',
		})}
		list={dashList}
		variant="radio"
		withSearch={false}
		selectCardClass="text-capitalize"
		bind:allCardsRefs={allDashRefs}
		on:click={(e) => onSelectDash(e.detail)}
	>
		<Button
			icon="fas fa-plus"
			variant="secondary"
			slot="select-list-custom-card"
			on:click={onShowAddDashModal}
		>
			{capFirstChar($format('text_sub_title_add_dashboard', { default: 'Add dashboard' }))}
		</Button>
	</SelectList>

	<DashAddEditActionModal bind:showModal={showAddDashModal} />
{/if}

<DashWidgetPositionStep bind:editItem hideSeparator={hideSelectDash} />
